import { FlowType } from '@tt4b/ttam-enums';
import { InventoryFlowTypeOptionItem, VSAInventoryFlowTypesItem } from './types';
import { i18n } from './../../../i18n';

export const InventoryFlowTypes: () => InventoryFlowTypeOptionItem[] = () => [
  {
    value: FlowType.AUTO,
    text: i18n.t('adgroup_placement_automatic'),
    teaKey: 'create_adgroup_placement_auto',
    tipsLinkTeaKey: 'create_adgroup_placement_auto_learnMore',
    tipsText: i18n.t('adgroup_placement_automatic_tips'),
    tipsLinkUrl: '/help/article?aid=6725594834129649670',
    tipsLinkText: i18n.t('adformat_learn_more'),
  },
  {
    value: FlowType.SELECTED,
    text: i18n.t('adgroup_placement_select'),
    teaKey: 'create_adgroup_placement_manual',
    tipsLinkTeaKey: 'create_adgroup_placement_auto_learnMore',
    tipsText: i18n.t('adgroup_placement_select_tips'),
    tipsLinkUrl: '/help/article?aid=6725594834129649670',
    tipsLinkText: i18n.t('adformat_learn_more'),
  },
];

export const GetVSAInventoryFlowTypesItem = (isAuto = true): VSAInventoryFlowTypesItem => ({
  text: i18n.t('adgroup_placement_automatic'),
  tipsLinkTeaKey: 'create_adgroup_placement_auto_learnMore',
  tipsText: isAuto
    ? i18n.t('adgroup_placement_automatic_all_tips')
    : i18n.t('adgroup_placement_automatic_only_tt_tips'),
  tipsLinkUrl: isAuto ? '/help/article/about-autoplacement' : '/help/article/about-onsite-shopping-placements',
  tipsLinkText: i18n.t('adformat_learn_more'),
});
